import React from "react";
export function usePreviousProps(props) {
  var ref = React.useRef();
  React.useEffect(function () {
    ref.current = props;
  });
  return ref.current;
}